import menu from "magicbean-saas-common/src/core/language/de/menu.json";
import common from "./common.json";

export default {
  menu,
  common,
};
